module.exports = __webpack_public_path__ + "img/icon-chevron-right-green.b096861f.svg";